module.exports = __webpack_public_path__ + "img/David_Chen.48c343d9.jpg";